
import {gql} from '@apollo/client';

export const listQuery = gql`
query getWaitList($path: String!) {
	list(path: $path) {
		id
		location
		due
		captured
		incentives {
			id
			target
			outcome
		}
		desktop {
			id
			url
		}
		mobile {
			id
			url
		}
		logo {
			id
			url
		}
	}
}`;

export interface WaitListIncentive {
	id: string
	target: number
	outcome: string
}

export type WaitListData = {
	list?: {
		id: string
		location: string
		due?: string
		captured: number
		incentives: WaitListIncentive[],
		desktop: {
			id: string
			url: string
		}
		mobile?: {
			id: string
			url: string
		}
		logo?: {
			id: string
			url: string
		}
	}
}

export const contactQuery = gql`
mutation addContact(
	$firstName: String!,
	$lastName: String!,
	$email: Email!,
	$zipCode: String!,
	$path: String!,
) {
	contact {
		capture(
			reason: INTEREST_LIST,
			path: $path,
			email: $email,
			firstName: $firstName,
			lastName: $lastName,
			zipCode: $zipCode,
		)
	}
}`;

export const viewQuery = gql`
mutation addView(
	$uuid: Email!,
	$path: String!,
) {
	contact {
		capture(
			reason: INTEREST_VIEW,
			path: $path,
			email: $uuid,
		)
	}
}`;

export type ContactData = {
	contact: {
		capture: boolean
	}
}
